export default "__VITE_ASSET__vnfYKicM__"